import { fichesPremium, universTech, boutiquesExt } from "./catalogue-extended";

export interface Product {
  id: string;
  name: string;
  badge?: string;
  category: string;
  description: string;
  price: number;
  oldPrice?: number;
  image: string;
  rating?: number;
  reviews?: number;
}

export interface Monde {
  id: string;
  name: string;
  tagline: string;
  image: string;
  features: string[];
}

export interface Merveille {
  id: string;
  badge: string;
  category: string;
  name: string;
  tagline: string;
  image: string;
  products: { name: string; price: number }[];
}

export const formatPrice = (price: number) => {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

// ═══════════ LES 5 MONDES ═══════════
export const mondes: Monde[] = [
  {
    id: "mobile",
    name: "Monde Mobile",
    tagline: "Luxury Smartphones & 5G",
    image: "/images/products/galaxy-s25-ultra.png",
    features: ["5G Ultra Speed", "Data Illimité VIP", "e-SIM Premium", "Roaming Afrique"],
  },
  {
    id: "tv-av",
    name: "Monde TV & AV",
    tagline: "Écrans d'Exception & Home Cinéma",
    image: "/images/products/smart-tv-8k.png",
    features: ["8K OLED & MicroLED", "Dolby Atmos", "Cadres Lifestyle", "Installation Concierge"],
  },
  {
    id: "electro",
    name: "Monde Électroménager",
    tagline: "Prestige & Cuisine Connectée",
    image: "/images/products/robot-cuisine.png",
    features: ["Robots Cuisiniers IA", "Réfrigérateurs Family Hub", "Climatisation Wind-Free", "Lave-linge AI"],
  },
  {
    id: "iot",
    name: "Monde Objets Connectés",
    tagline: "Wearables & Smart Home",
    image: "/images/products/galaxy-watch-ultra.png",
    features: ["Montres Premium", "Écouteurs ANC", "Caméras 4K IA", "Hubs Domotique"],
  },
  {
    id: "cloud",
    name: "Monde Cloud & Data",
    tagline: "Solutions Entreprise & IA",
    image: "/images/products/pc-pro-pack.png",
    features: ["Packs Pro Complets", "Imprimantes Laser", "Routeurs 5G WiFi 7", "Support 24/7"],
  },
];

// ═══════════ LES 7 MERVEILLES ═══════════
export const merveilles: Merveille[] = [
  {
    id: "perle-mobile",
    badge: "PLATINIUM",
    category: "Mobile",
    name: "La Perle Mobile",
    tagline: "Smartphones Haute Joaillerie",
    image: "/images/products/galaxy-s25-ultra.png",
    products: [
      { name: "Galaxy S25 Ultra Titanium", price: 1299000 },
      { name: "iPhone 15 Pro Max", price: 1499000 },
    ],
  },
  {
    id: "oasis-visuelle",
    badge: "EXCLUSIF",
    category: "TV & AV",
    name: "L'Oasis Visuelle",
    tagline: "Écrans & TV de Collection",
    image: "/images/products/smart-tv-8k.png",
    products: [
      { name: "Smart TV 8K OLED 85\"", price: 4999000 },
      { name: "The Frame 75\" Lifestyle", price: 2499000 },
    ],
  },
  {
    id: "sanctuaire-sonore",
    badge: "HI-FI",
    category: "TV & AV",
    name: "Le Sanctuaire Sonore",
    tagline: "Audio Audiophile & Hi-Fi",
    image: "/images/products/soundbar-q990d.png",
    products: [
      { name: "Soundbar Q990D Atmos 7.1.4", price: 899000 },
      { name: "Galaxy Buds3 Pro ANC", price: 149000 },
    ],
  },
  {
    id: "zenith-gaming",
    badge: "PRO",
    category: "Gaming",
    name: "Le Zénith Gaming",
    tagline: "E-Sports & Performance",
    image: "/images/products/gaming-setup.png",
    products: [
      { name: "Setup Gamer RTX 5090 + OLED", price: 4999000 },
      { name: "Monitor OLED 240Hz 27\"", price: 999000 },
    ],
  },
  {
    id: "bracelet-or",
    badge: "LUXE",
    category: "IoT",
    name: "Le Bracelet d'Or",
    tagline: "Wearables Luxury & Santé",
    image: "/images/products/galaxy-watch-ultra.png",
    products: [
      { name: "Galaxy Watch Ultra Titanium", price: 549000 },
      { name: "Apple Watch Hermès S9", price: 1299000 },
    ],
  },
  {
    id: "palais-intelligent",
    badge: "VILLA",
    category: "Électro",
    name: "Le Palais Intelligent",
    tagline: "Domotique Prestige & Villa",
    image: "/images/products/camera-4k-dome.png",
    products: [
      { name: "Caméra IP 4K AI Dome", price: 199000 },
      { name: "Smart Home Hub Premium", price: 149000 },
    ],
  },
  {
    id: "crystal-data",
    badge: "ENTERPRISE",
    category: "Cloud",
    name: "Le Crystal Data",
    tagline: "Cloud Enterprise & IA",
    image: "/images/products/pc-pro-pack.png",
    products: [
      { name: "PC Pro + Imprimante + Routeur 5G", price: 1499000 },
      { name: "Imprimante LaserJet Pro M404", price: 399000 },
    ],
  },
];

// ═══════════ PRODUITS DU MOMENT ═══════════
export const produitsMoment: Product[] = [
  {
    id: "pack-pro",
    name: "Solution Pro Complète",
    badge: "BEST VALUE",
    category: "Pack Pro",
    description: "PC Portable + Imprimante + Routeur 5G + Installation clé en main. Support dédié 24/7",
    price: 1499000,
    oldPrice: 1899000,
    image: "/images/products/pc-pro-pack.png",
  },
  {
    id: "iphone-15-pro-max",
    name: "iPhone 15 Pro Max",
    badge: "BEST SELLER",
    category: "Mobile",
    description: "Titanium A17 Pro. Camera 48MP. Le smartphone le plus désiré au Sénégal",
    price: 1499000,
    oldPrice: 1799000,
    image: "/images/products/iphone-15-pro-max.png",
  },
  {
    id: "robot-cuisine",
    name: "Robot Cuisine Samsung",
    badge: "NOUVEAUTÉ",
    category: "Électroménager",
    description: "Robot cuisinier intelligent avec 100+ recettes sénégalaises intégrées",
    price: 899000,
    oldPrice: 1099000,
    image: "/images/products/robot-cuisine.png",
  },
  {
    id: "setup-gamer",
    name: "Setup Gamer Elite",
    badge: "PRO GAMER",
    category: "Gaming",
    description: "PC RTX 5090 + Monitor OLED 240Hz + Clavier/Casque méca. Le setup ultime",
    price: 4999000,
    oldPrice: 5999000,
    image: "/images/products/gaming-setup.png",
  },
  {
    id: "camera-4k",
    name: "Caméra IP 4K AI Dome",
    badge: "SÉCURITÉ",
    category: "Maison",
    description: "Caméra 4K avec IA de détection, vision nocturne et alertes smartphone",
    price: 199000,
    oldPrice: 249000,
    image: "/images/products/camera-4k-dome.png",
  },
  {
    id: "tv-8k-oled",
    name: "Smart TV 8K OLED 85\"",
    badge: "EXCLUSIF",
    category: "TV & AV",
    description: "OLED 8K, Neural AI Processor, Dolby Atmos. Le cinéma chez vous",
    price: 4999000,
    oldPrice: 5999000,
    image: "/images/products/smart-tv-8k.png",
  },
  {
    id: "galaxy-watch-ultra",
    name: "Galaxy Watch Ultra",
    badge: "PLATINIUM",
    category: "Wearable",
    description: "Titanium Grade 4. GPS multi-band. 100m water resistance. Santé pro",
    price: 549000,
    oldPrice: 699000,
    image: "/images/products/galaxy-watch-ultra.png",
  },
  {
    id: "bespoke-fridge",
    name: "Bespoke French Door 680L",
    badge: "DESIGN",
    category: "Électroménager",
    description: "Réfrigérateur connecté Family Hub avec écran tactile et AI Inside",
    price: 2199000,
    oldPrice: 2699000,
    image: "/images/presidential/refrigerateur-bespoke.png",
  },
  {
    id: "pm-galaxy-ring",
    name: "Galaxy Ring Titanium",
    badge: "INNOVATION",
    category: "Wearable",
    description: "Suivi sommeil & cardio 24/7 dans 2,3g de titanium. La santé invisible au doigt",
    price: 449000,
    oldPrice: 499000,
    image: "/images/products/galaxy-ring-titanium.png",
  },
  {
    id: "pm-tv-oled-65",
    name: "Smart TV OLED 4K 65\"",
    badge: "BEST SELLER",
    category: "TV & AV",
    description: "OLED 4K 120Hz, Dolby Vision IQ et son 2.2.2 intégré. Le best-seller de la maison",
    price: 1899000,
    oldPrice: 2299000,
    image: "/images/products/smart-tv-oled-65.png",
  },
  {
    id: "pm-expresso",
    name: "Machine Expresso Connectée",
    badge: "CAFFÈ",
    category: "Électroménager",
    description: "Extraction 19 bars, moulin intégré et 12 spécialités. Le café de palace à la maison",
    price: 549000,
    oldPrice: 649000,
    image: "/images/products/machine-expresso-connectee.png",
  },
  {
    id: "pm-pos",
    name: "Terminal Point de Vente Intelligent",
    badge: "COMMERÇANTS",
    category: "Solution Pro",
    description: "Wave, Orange Money et Visa intégrés. L'encaissement moderne des boutiques",
    price: 399000,
    oldPrice: 469000,
    image: "/images/products/terminal-point-de-vente.png",
  },
];

// ═══════════ COLLECTION PLATINUM ═══════════
export const collectionPlatinum: Product[] = [
  {
    id: "plat-s25-ultra",
    name: "Galaxy S25 Ultra Titanium",
    badge: "PLATINIUM",
    category: "Smartphone Édition Limitée",
    description: "Édition Titanium numérotée, accessoires cuir offerts",
    price: 1299000,
    oldPrice: 1599000,
    image: "/images/products/galaxy-s25-ultra.png",
    rating: 4.9,
    reviews: 342,
  },
  {
    id: "plat-tv-8k",
    name: "Smart TV 8K OLED 85\"",
    badge: "EXCLUSIF",
    category: "Télévision Collection",
    description: "Panneau OLED 8K certifié, installation murale concierge",
    price: 4999000,
    oldPrice: 5999000,
    image: "/images/products/smart-tv-8k.png",
    rating: 4.8,
    reviews: 128,
  },
  {
    id: "plat-clim",
    name: "Climatiseur Wind-Free AI",
    badge: "BEST SELLER",
    category: "Électroménager Premium",
    description: "Refroidissement sans courant d'air piloté par IA",
    price: 899000,
    oldPrice: 1099000,
    image: "/images/presidential/climatiseur-windfree.png",
    rating: 4.7,
    reviews: 567,
  },
  {
    id: "plat-watch",
    name: "Galaxy Watch Ultra Titanium",
    badge: "NOUVEAU",
    category: "Wearable Luxury",
    description: "Boîtier Titanium Grade 4, bracelet boucle titane",
    price: 549000,
    oldPrice: 699000,
    image: "/images/products/galaxy-watch-ultra.png",
    rating: 4.9,
    reviews: 89,
  },
  {
    id: "plat-soundbar",
    name: "Soundbar HW-Q990D Atmos",
    badge: "HI-FI",
    category: "Audio Premium",
    description: "11.1.4 canaux, subwoofer sans fil, up-mixing IA",
    price: 899000,
    oldPrice: 1099000,
    image: "/images/products/soundbar-q990d.png",
    rating: 4.8,
    reviews: 214,
  },
  {
    id: "plat-robot",
    name: "Robot Cuisine Samsung Food",
    badge: "INNOVATION",
    category: "Cuisine Smart",
    description: "100+ recettes sénégalaises, connecté SmartThings",
    price: 899000,
    oldPrice: 1099000,
    image: "/images/products/robot-cuisine.png",
    rating: 4.9,
    reviews: 47,
  },
  {
    id: "plat-projecteur-ust",
    name: "Projecteur Laser Ultra-Short 4K",
    badge: "HOME CINÉMA",
    category: "Projection Prestige",
    description: "Projection 120\" à 20cm du mur, laser 2 800 lumens et calibration ISF",
    price: 2999000,
    oldPrice: 3499000,
    image: "/images/products/projecteur-laser-ust.png",
    rating: 4.9,
    reviews: 33,
  },
  {
    id: "plat-casque-signature",
    name: "Casque Signature Diamant ANC",
    badge: "HAUTE JOAILLERIE",
    category: "Audio d'Exception",
    description: "Écouteurs or 24K sertis diamants, cuir vert émeraude et ANC audiophile",
    price: 549000,
    oldPrice: 649000,
    image: "/images/products/casque-signature-diamant.png",
    rating: 5,
    reviews: 11,
  },
];

// ═══════════⭐ LES MERVEILLES PRÉSIDENTIELLES ⭐═══════════
export interface PresidentialProduct extends Product {
  edition: string;
  prestige: string[];
}

export const merveillesPresidentielles: PresidentialProduct[] = [
  {
    id: "pres-teranga-gold",
    name: "Smartphone Président « Teranga Gold »",
    badge: "ÉDITION NUMÉROTÉE",
    category: "Smartphone d'État",
    description: "Or 24K et Titanium Grade 5, gravé à la main. Cryptographie souveraine, ligne protocolaire dédiée et coffret palissandre. Série limitée à 1 960 exemplaires en hommage à l'Indépendance.",
    price: 9999000,
    oldPrice: 12999000,
    image: "/images/presidential/smartphone-teranga-gold.png",
    edition: "Série 1 960 ex.",
    prestige: ["Or 24K gravé main", "Chiffrement souverain", "Ligne protocolaire 24/7", "Coffret palissande & or"],
  },
  {
    id: "pres-microled",
    name: "MicroLED Palais 110\"",
    badge: "ÉCRAN D'ÉTAT",
    category: "Affichage Présidentiel",
    description: "Monolith 110 pouces MicroLED 8K, cadre en or massif et marbre vert émeraude. Calibration cinéma d'État, son intégré 6.4.4 et mode Cérémonie Protocolaire.",
    price: 14999000,
    oldPrice: 17999000,
    image: "/images/presidential/microled-palais-110.png",
    edition: "Pièce d'exception",
    prestige: ["MicroLED 8K 110\"", "Cadre or massif 18K", "Son 6.4.4 intégré", "Mode Cérémonie d'État"],
  },
  {
    id: "pres-montre",
    name: "Montre d'État « Savoir-Faire »",
    badge: "HAUTE JOAILLERIE",
    category: "Horlogerie Présidentielle",
    description: "Or massif 18K, lunette sertie de 52 diamants, cadran émeraude du Sénégal. Mouvement connecté hybride, GPS multi-bandes et gravure des armoiries sur demande.",
    price: 7499000,
    oldPrice: 9499000,
    image: "/images/presidential/montre-etat-or.png",
    edition: "Série 500 ex.",
    prestige: ["Or 18K & 52 diamants", "Cadran émeraude", "GPS multi-bandes", "Armoiries gravées"],
  },
  {
    id: "pres-bureau",
    name: "Bureau du Sommet",
    badge: "SETUP PRÉSIDENTIEL",
    category: "Bureau d'Exception",
    description: "Setup complet du chef d'État : palissandre massif, laptop or-titane, téléphone chiffré Quantique, stylo connecté et tableau de bord national temps réel.",
    price: 12499000,
    oldPrice: 14999000,
    image: "/images/presidential/bureau-du-sommet.png",
    edition: "Sur-mesure",
    prestige: ["Palissandre massif", "Laptop or & titane", "Téléphone quantique", "Dashboard national"],
  },
  {
    id: "pres-conseil",
    name: "Table du Conseil Suprême 86\"",
    badge: "SALLE DU CONSEIL",
    category: "Gouvernement Digital",
    description: "Table tactile 86 pouces 8K pour conseil des ministres, visioconférence chiffrée de niveau souverain, vote électronique sécurisé et affichage géostratégique du territoire.",
    price: 19999000,
    oldPrice: 24999000,
    image: "/images/presidential/table-conseil-supreme.png",
    edition: "Installée sur site",
    prestige: ["Tactile 8K 86\"", "Visio souveraine", "Vote électronique", "Cartographie temps réel"],
  },
  {
    id: "pres-bastion",
    name: "Bastion Présidentiel",
    badge: "SÉCURITÉ SOUVERAINE",
    category: "Cybersécurité d'État",
    description: "Coffre-fort cyber avec biométrie triple facteur, SOC privé, détection IA zero-day et chambre blindée TEMPEST. La protection ultime des données souveraines.",
    price: 8999000,
    oldPrice: 10999000,
    image: "/images/presidential/bastion-presidentiel.png",
    edition: "Certifié TEMPEST",
    prestige: ["Biométrie 3 facteurs", "SOC privé 24/7", "IA zero-day", "Chambre blindée TEMPEST"],
  },
  {
    id: "pres-villa",
    name: "Villa Présidentielle Intelligente",
    badge: "DOMOTIQUE D'ÉTAT",
    category: "Résidence Connectée",
    description: "Pack domotique complet pour résidence d'exception : 40 pièces pilotées, sécurité périmétrique IA, éclairage protocolaire, helipad connecté et abri sécurisé intégré.",
    price: 24999000,
    oldPrice: 29999000,
    image: "/images/presidential/villa-presidentielle.png",
    edition: "Projet clé en main",
    prestige: ["40 pièces pilotées", "Sécurité périmétrique IA", "Éclairage protocolaire", "Helipad connecté"],
  },
  {
    id: "pres-audio",
    name: "Sanctuaire Audio d'État",
    badge: "SON DE PALAIS",
    category: "Audio Protocolaire",
    description: "Système acoustique de palais 15.4.6 Dolby Atmos, enceintes colonne or-massif, calibration d'architecte et mode hymne national avec compensation acoustique adaptative.",
    price: 11999000,
    oldPrice: 14499000,
    image: "/images/presidential/sanctuaire-audio-etat.png",
    edition: "Calibration d'architecte",
    prestige: ["Dolby 15.4.6", "Colonne or-massif", "Calibration d'architecte", "Mode Hymne National"],
  },
];

// ═══════════ SOLUTIONS PRO ═══════════
export interface ProSolution {
  id: string;
  badge: string;
  name: string;
  tagline: string;
  description: string;
  features: string[];
  clients: string;
  metric: string;
}

export const solutionsPro: ProSolution[] = [
  {
    id: "pro-complet",
    badge: "Pack #1 au Sénégal",
    name: "Solution Pro Complète",
    tagline: "PC + Imprimante + Routeur 5G",
    description: "Pack clé en main : PC portable pro HP/Dell, imprimante LaserJet, routeur 5G WiFi 7 et installation complète par nos techniciens. Support dédié 24/7 inclus.",
    features: ["PC Portable Pro", "Imprimante LaserJet", "Routeur 5G WiFi 7", "Installation Clé en Main"],
    clients: "Bureaux, Cabinets, Startups",
    metric: "+340% adoption",
  },
  {
    id: "ia-generative",
    badge: "+340% adoption",
    name: "IA Générative & Automatisation",
    tagline: "La révolution intelligente",
    description: "Déployez l'IA générative : chatbots wolof/français, analyse prédictive, automatisation RPA et assistants virtuels pour le marché africain.",
    features: ["Chatbots IA Wolof/Fr", "Analyse Prédictive", "RPA Automatisation", "Computer Vision"],
    clients: "Banques, Assurances",
    metric: "+340% adoption",
  },
  {
    id: "cloud-hybride",
    badge: "+220% croissance",
    name: "Cloud Hybride & Data Center",
    tagline: "Infrastructure agile & sécurisée",
    description: "Data center Tier III à Dakar avec cloud hybride public/privé. Kubernetes managé, stockage S3 et réseau SD-WAN Afrique-Europe.",
    features: ["Tier III Dakar", "Kubernetes Managé", "SD-WAN Afrique", "S3 Stockage Objet"],
    clients: "Banques, Gouvernement",
    metric: "+220% croissance",
  },
  {
    id: "cybersec",
    badge: "+180% menaces bloquées",
    name: "Cybersécurité 360°",
    tagline: "Protection nouvelle génération",
    description: "SOC 24/7, détection IA zero-day, firewall next-gen, EDR/XDR et pentest certifié. Protection complète contre les cybermenaces.",
    features: ["SOC 24/7 Dakar", "Zero-Trust IA", "EDR/XDR Next-Gen", "Pentest Certifié"],
    clients: "Banques, Défense, Énergie",
    metric: "+180% menaces bloquées",
  },
  {
    id: "fintech",
    badge: "+450% transactions",
    name: "Fintech & Mobile Money",
    tagline: "Finance digitale inclusive",
    description: "Plateforme mobile money, API banking open-banking, KYC biométrique et micro-crédit algorithmique. Démocratisez les services financiers.",
    features: ["Mobile Money API", "Open Banking", "KYC Biométrique", "Micro-Crédit AI"],
    clients: "Wave, Orange, Banques",
    metric: "+450% transactions",
  },
  {
    id: "iot-smart-city",
    badge: "+290% déploiements",
    name: "IoT & Smart City",
    tagline: "Villes et usines intelligentes",
    description: "Capteurs LoRaWAN, plateforme IoT, digital twin smart factory et solutions smart city (éclairage, déchets, trafic). Transformez votre ville.",
    features: ["LoRaWAN Capteurs", "Digital Twin", "Smart City Platform", "Maintenance IA"],
    clients: "Mairie Dakar, Mines",
    metric: "+290% déploiements",
  },
];

// ═══════════ PROMOS ═══════════
export interface Promo {
  id: string;
  discount: number;
  badge: string;
  endsIn: string;
  title: string;
  subtitle: string;
  description: string;
  items: string[];
  fromPrice: number;
  image: string;
  presidential?: boolean;
}

export const promos: Promo[] = [
  {
    id: "promo-prestige",
    discount: 40,
    badge: "EVENT LUXE",
    endsIn: "3 jours",
    title: "Soldes Prestige Été",
    subtitle: "Jusqu'à -40% sur les Smartphones Luxe",
    description: "Galaxy S25 Ultra, iPhone 15 Pro Max et Galaxy Z Fold6 à des prix jamais vus. Édition Titanium avec accessoires premium offerts et garantie 3 ans.",
    items: ["Galaxy S25 Ultra", "iPhone 15 Pro Max", "Galaxy Z Fold6"],
    fromPrice: 799000,
    image: "/images/products/galaxy-s25-ultra.png",
  },
  {
    id: "promo-gaming",
    discount: 35,
    badge: "FLASH DEAL",
    endsIn: "24 heures",
    title: "Flash Deal Gaming",
    subtitle: "Setup Gamer & Écrans -35%",
    description: "Offre éclair sur les setups gaming les plus prestigieux. RTX 5090, écrans OLED 240Hz et casques 7.1 Pro avec garanties étendues. Stock très limité.",
    items: ["Setup RTX 5090", "Monitor OLED 240Hz", "Casque 7.1 Pro"],
    fromPrice: 2999000,
    image: "/images/products/gaming-setup.png",
  },
  {
    id: "promo-villa",
    discount: 30,
    badge: "PACK VILLA",
    endsIn: "5 jours",
    title: "Pack Villa Intelligente",
    subtitle: "Maison Connectée -30%",
    description: "Équipez votre villa avec notre pack Smart Home premium. SmartThings Hub, 6 caméras 4K AI, éclairage architectural et thermostat AI.",
    items: ["SmartThings Hub Pro", "6x Caméras 4K AI", "Éclairage Architectural"],
    fromPrice: 499000,
    image: "/images/products/smart-home-hub.png",
  },
  {
    id: "promo-cuisine",
    discount: 25,
    badge: "CUISINE SMART",
    endsIn: "7 jours",
    title: "Robot Cuisine & Électroménager",
    subtitle: "Cuisine Smart -25%",
    description: "Le meilleur de la cuisine connectée Samsung. Robot Food, réfrigérateur Bespoke French Door et climatisation Wind-Free AI pour un confort total.",
    items: ["Robot Cuisine Samsung Food", "Bespoke French Door", "Wind-Free AI"],
    fromPrice: 699000,
    image: "/images/products/robot-cuisine.png",
  },
  {
    id: "promo-presidentielle",
    discount: 23,
    badge: "OFFRE PRÉSIDENTIELLE",
    endsIn: "Édition limitée",
    title: "Merveilles Présidentielles",
    subtitle: "Collection d'État -23%",
    description: "L'élite absolue de la technologie : Smartphone Teranga Gold, MicroLED Palais 110\" et Montre d'État. Accompagnement protocolaire et garantie souveraine 5 ans.",
    items: ["Smartphone Teranga Gold", "MicroLED Palais 110\"", "Montre d'État Savoir-Faire"],
    fromPrice: 7499000,
    image: "/images/presidential/smartphone-teranga-gold.png",
    presidential: true,
  },
  {
    id: "promo-audio",
    discount: 30,
    badge: "SON & HI-FI",
    endsIn: "4 jours",
    title: "Semaine du Son Premium",
    subtitle: "Audio Audiophile -30%",
    description: "Soundbars Dolby Atmos, écouteurs ANC et enceintes connectées en promotion exclusive. L'immersion sonore totale pour votre salon, à prix concours.",
    items: ["Soundbar Q990D Atmos", "Galaxy Buds3 Pro ANC", "Enceinte Connectée Premium"],
    fromPrice: 149000,
    image: "/images/products/soundbar-q990d.png",
  },
  {
    id: "promo-mobile-flash",
    discount: 20,
    badge: "FLASH 48H",
    endsIn: "48 heures",
    title: "Flash Mobile Premium",
    subtitle: "Smartphones Signature -20%",
    description: "Offre éclair de 48 heures sur les smartphones signature. iPhone 15 Pro Max, Galaxy S25 Edge Émeraude et Galaxy Z Fold6 avec accessoires cuir offerts.",
    items: ["iPhone 15 Pro Max", "Galaxy S25 Edge", "Galaxy Z Fold6"],
    fromPrice: 999000,
    image: "/images/products/galaxy-z-fold6.png",
  },
  {
    id: "promo-cloud-pro",
    discount: 15,
    badge: "ENTREPRISE",
    endsIn: "10 jours",
    title: "Pack Cloud Enterprise",
    subtitle: "Équipement Pro -15%",
    description: "Équipez votre entreprise : laptop or-titane, écran pro 4K 32\", imprimante LaserJet et routeur WiFi 7. Installation sur site et support dédié 24/7 inclus.",
    items: ["Laptop Or-Titane", "Écran Pro 32\" 4K", "Routeur WiFi 7", "Imprimante LaserJet"],
    fromPrice: 899000,
    image: "/images/products/pc-pro-pack.png",
  },
];

// ═══════════ FORFAITS 5G ═══════════
export interface Forfait {
  id: string;
  name: string;
  price: number;
  speed: string;
  data: string;
  features: string[];
  popular?: boolean;
  presidential?: boolean;
}

export const forfaits: Forfait[] = [
  {
    id: "for-essentiel",
    name: "Teranga 5G Essentiel",
    price: 15000,
    speed: "5G Standard · 300 Mb/s",
    data: "50 Go puis vitesse réduite",
    features: ["Appels illimités Sénégal", "SMS illimités", "Streaming HD", "e-SIM offerte"],
  },
  {
    id: "for-premium",
    name: "Teranga 5G Premium",
    price: 35000,
    speed: "5G Ultra · 1 Gb/s",
    data: "150 Go full speed",
    features: ["Appels illimités Afrique de l'Ouest", "Roaming 15 pays", "Multi-appareils (3 e-SIM)", "Priorité réseau aux heures de pointe"],
    popular: true,
  },
  {
    id: "for-platinum",
    name: "Teranga 5G Platinum",
    price: 60000,
    speed: "5G Ultra+ · 2 Gb/s",
    data: "Illimité vraiment illimité",
    features: ["Appels & SMS illimités monde", "Roaming 120 pays", "6 e-SIM · WiFi Calling VIP", "Concierge télécom dédié 24/7"],
  },
  {
    id: "for-presidentiel",
    name: "Forfait Présidentiel Souverain",
    price: 250000,
    speed: "Réseau dédié chiffré · 5 Gb/s",
    data: "Illimité souverain",
    features: ["Ligne protocolaire chiffrée de bout en bout", "SIM souveraine à clés physiques", "Anti-écoute & masking géolocalisation", "Escorte cyber mobile à domicile"],
    presidential: true,
  },
];

// ═══════════ BOUTIQUES DES 5 MONDES (base) ═══════════
const boutiquesBase: Record<string, Product[]> = {
  mobile: [
    { id: "mob-s25u", name: "Galaxy S25 Ultra Titanium", badge: "BEST SELLER", category: "Smartphone", description: "Titanium Grade 5, S Pen intégré, capteur 200MP et IA Galaxy. Le sommet absolu de l'Android.", price: 1299000, oldPrice: 1599000, image: "/images/products/galaxy-s25-ultra.png", rating: 4.9, reviews: 342 },
    { id: "mob-iphone15pm", name: "iPhone 15 Pro Max", badge: "ICÔNE", category: "Smartphone", description: "Titanium A17 Pro, camera 48MP et USB-C. Le smartphone le plus désiré au Sénégal.", price: 1499000, oldPrice: 1799000, image: "/images/products/iphone-15-pro-max.png", rating: 4.9, reviews: 517 },
    { id: "mob-zfold6", name: "Galaxy Z Fold6 Limited", badge: "ÉDITION LIMITÉE", category: "Smartphone Pliable", description: "Pliable premium avec multitâche IA, verre Gorilla Armor et finition cuir exclusive.", price: 1799000, oldPrice: 2099000, image: "/images/products/galaxy-z-fold6.png", rating: 4.8, reviews: 128 },
    { id: "mob-s25edge", name: "Galaxy S25 Edge Émeraude", badge: "NOUVEAUTÉ", category: "Smartphone", description: "Design ultra-fin 5,8 mm, écran Edge incurvé émeraude et autonomie 2 jours.", price: 999000, oldPrice: 1199000, image: "/images/products/smartphone-edge-vert.png", rating: 4.7, reviews: 76 },
    { id: "mob-watchu", name: "Galaxy Watch Ultra Titanium", badge: "SPORT PREMIUM", category: "Montre Connectée", description: "Titanium Grade 4, GPS multi-bandes, 100m water resistance et suivi santé pro.", price: 549000, oldPrice: 699000, image: "/images/products/galaxy-watch-ultra.png", rating: 4.9, reviews: 89 },
    { id: "mob-buds3", name: "Galaxy Buds3 Pro ANC", badge: "AUDIO", category: "Écouteurs", description: "Réduction de bruit adaptative 24-bit, audio 360 et boîtier de charge premium.", price: 149000, oldPrice: 189000, image: "/images/products/galaxy-buds3-pro.png", rating: 4.8, reviews: 231 },
    { id: "mob-tab-s10", name: "Tablette Ultra Tab S10+", badge: "CRÉATEURS", category: "Tablette", description: "Écran AMOLED 12,4\", stylet S Pen inclus et mode DeX pour travailler partout.", price: 849000, oldPrice: 999000, image: "/images/products/tablette-premium.png", rating: 4.8, reviews: 94 },
    { id: "mob-aw-hermes", name: "Apple Watch Hermès S9", badge: "HAUTE COUTURE", category: "Montre Connectée", description: "Bracelets Hermès exclusifs, titane naturel et double-batterie. Le luxe au poignet.", price: 1299000, image: "/images/products/apple-watch-hermes.png", rating: 4.9, reviews: 41 },
    { id: "mob-zflip6", name: "Galaxy Z Flip6 Argent", badge: "PLIABLE", category: "Smartphone Pliable", description: "Format poche compact, écran Flex 6,7\" et caméra 50MP auto-pose. L'élégance qui se plie à votre style.", price: 949000, oldPrice: 1149000, image: "/images/products/galaxy-z-flip6.png", rating: 4.7, reviews: 83 },
    { id: "mob-tecno-fold2", name: "Tecno Phantom V Fold2 5G", badge: "PANAFRICAIN", category: "Smartphone Pliable", description: "Pliable grand format 5G, batterie 5 200 mAh et multitâche triple écran. La fierté africaine.", price: 699000, oldPrice: 849000, image: "/images/products/tecno-phantom-fold2.png", rating: 4.6, reviews: 57 },
    { id: "mob-infinix-note40", name: "Infinix Note 40 Pro 5G", badge: "MEILLEUR PRIX", category: "Smartphone", description: "Charge All-Round 70W, écran AMOLED incurvé 120Hz et capteur 108MP. Le meilleur rapport qualité-prix.", price: 219000, oldPrice: 269000, image: "/images/products/infinix-note40-pro.png", rating: 4.6, reviews: 412 },
    { id: "mob-xiaomi14u", name: "Xiaomi 14 Ultra Leica", badge: "PHOTOGRAPHIE", category: "Smartphone", description: "Optique Leica Summilux, capteur 1\" 4-canaux et zoom 5x. L'appareil photo qui téléphone.", price: 1099000, oldPrice: 1299000, image: "/images/products/xiaomi-14-ultra.png", rating: 4.8, reviews: 96 },
    { id: "mob-honor-magic6", name: "HONOR Magic6 Pro", badge: "INNOVATION", category: "Smartphone", description: "Batterie silicium-carbone 5 600 mAh, écran 120Hz LTPO et capture Falcon. L'avant-garde du mobile.", price: 849000, oldPrice: 999000, image: "/images/products/honor-magic6-pro.png", rating: 4.7, reviews: 74 },
    { id: "mob-pixel9pro", name: "Google Pixel 9 Pro", badge: "IA GOOGLE", category: "Smartphone", description: "Gemini intégré, photo 50MP best-in-class et 7 ans de mises à jour. L'IA avant tout.", price: 1149000, image: "/images/products/pixel-9pro.png", rating: 4.8, reviews: 68 },
    { id: "mob-powerbank", name: "Powerbank Solaire 25 000 mAh", badge: "ÉNERGIE", category: "Énergie Mobile", description: "Panneau solaire intégré, 3 sorties rapides 65W et lampes LED. L'énergie partout au Sénégal.", price: 79000, oldPrice: 99000, image: "/images/products/powerbank-solaire.png", rating: 4.5, reviews: 287 },
    { id: "mob-station3en1", name: "Station de Charge 3-en-1", badge: "DESIGN", category: "Accessoire Premium", description: "Charge magnétique téléphone + montre + écouteurs, aluminium champagne et pliage voyage.", price: 89000, image: "/images/products/station-charge-3en1.png", rating: 4.7, reviews: 134 },
  ],
  "tv-av": [
    { id: "tv-8k85", name: "Smart TV 8K OLED 85\"", badge: "FLAGSHIP", category: "Télévision", description: "OLED 8K, Neural AI Processor et Dolby Atmos. Le cinéma monumental chez vous.", price: 4999000, oldPrice: 5999000, image: "/images/products/smart-tv-8k.png", rating: 4.8, reviews: 128 },
    { id: "tv-frame75", name: "The Frame 75\" Lifestyle", badge: "DESIGN", category: "Télévision", description: "TV-cadre d'art avec mode Art Gallery, mate display et pieds décoratifs.", price: 2499000, oldPrice: 2899000, image: "/images/products/the-frame-75.png", rating: 4.7, reviews: 167 },
    { id: "tv-q990d", name: "Soundbar HW-Q990D Atmos", badge: "HI-FI", category: "Barre de Son", description: "11.1.4 canaux, subwoofer sans fil et up-mixing IA pour une immersion totale.", price: 899000, oldPrice: 1099000, image: "/images/products/soundbar-q990d.png", rating: 4.8, reviews: 214 },
    { id: "tv-projector", name: "Vidéoprojecteur Laser 4K", badge: "HOME CINÉMA", category: "Projection", description: "Laser tri-source 4K HDR10+, 2800 lumens et correction auto du cadre.", price: 1899000, oldPrice: 2299000, image: "/images/products/videoprojecteur-4k.png", rating: 4.7, reviews: 58 },
    { id: "tv-microled", name: "MicroLED Palais 110\"", badge: "PIÈCE D'EXCEPTION", category: "Affichage Prestige", description: "MicroLED 8K modulaire 110 pouces avec cadre or massif et calibration d'État.", price: 14999000, oldPrice: 17999000, image: "/images/presidential/microled-palais-110.png", rating: 5, reviews: 12 },
    { id: "tv-sanctuaire", name: "Sanctuaire Audio d'État", badge: "SON DE PALAIS", category: "Audio Prestige", description: "Système 15.4.6 Dolby Atmos, enceintes colonne or-massif et calibration d'architecte.", price: 11999000, image: "/images/presidential/sanctuaire-audio-etat.png", rating: 5, reviews: 8 },
    { id: "tv-enceinte", name: "Enceinte Connectée Premium", badge: "SMART HOME", category: "Audio Connecté", description: "Assistant vocal wolof & français, son 360° et design tissu or.", price: 199000, oldPrice: 249000, image: "/images/products/enceinte-connectee.png", rating: 4.6, reviews: 143 },
    { id: "tv-monitor", name: "Monitor OLED 240Hz 27\"", badge: "GAMING", category: "Écran", description: "OLED 0,03ms, 240Hz, HDR True Black et design fin aluminium.", price: 999000, oldPrice: 1199000, image: "/images/products/monitor-oled-240hz.png", rating: 4.9, reviews: 186 },
    { id: "tv-oled65", name: "Smart TV OLED 4K 65\"", badge: "BEST SELLER", category: "Télévision", description: "OLED 4K 120Hz, Dolby Vision IQ et son 2.2.2 intégré. Le best-seller absolu.", price: 1899000, oldPrice: 2299000, image: "/images/products/smart-tv-oled-65.png", rating: 4.8, reviews: 231 },
    { id: "tv-qled55", name: "Smart TV QLED 4K 55\"", badge: "PAS CHER", category: "Télévision", description: "QLED 100% volume couleur, Smart TV Tizen et design AirSlim. L'entrée idéale dans le 4K.", price: 749000, oldPrice: 899000, image: "/images/products/smart-tv-qled-55.png", rating: 4.6, reviews: 356 },
    { id: "tv-casque-hifi", name: "Casque Hi-Fi sans fil ANC", badge: "AUDIO PREMIUM", category: "Casque Audio", description: "Réduction de bruit adaptative, coussins cuir et 32h d'autonomie. Le silence absolu.", price: 349000, oldPrice: 429000, image: "/images/products/casque-hifi-anc.png", rating: 4.8, reviews: 178 },
    { id: "tv-platine", name: "Platine Vinyle Édition Or", badge: "COLLECTION", category: "Audio Vintage", description: "Platine haut-parleur doré, préampli intégré et plateau acrylique fumé. Le rituel du vinyle.", price: 549000, image: "/images/products/platine-vinyle-or.png", rating: 4.9, reviews: 42 },
    { id: "tv-ampli", name: "Amplificateur Hi-Fi Premium", badge: "AUDIOPHILE", category: "Amplification", description: "VU-mètres analogiques, classe AB 2x120W et entrées phono/USB-DA. L'âme du son.", price: 899000, oldPrice: 1099000, image: "/images/products/amplificateur-hifi.png", rating: 4.9, reviews: 38 },
    { id: "tv-ecran16", name: "Écran Portable OLED 16\"", badge: "NOMADE", category: "Écran", description: "OLED 16\" 3,5K 60Hz, 700g et étui-support magnétique. Votre bureau partout.", price: 349000, image: "/images/products/ecran-portable-oled16.png", rating: 4.7, reviews: 91 },
    { id: "tv-subwoofer", name: "Subwoofer Sans Fil 12\"", badge: "BASSES PROFONDES", category: "Barre de Son", description: "Haut-parleur 12\" grave profond 24Hz, appairage sans fil Q-Symphony.", price: 449000, oldPrice: 549000, image: "/images/products/subwoofer-sans-fil.png", rating: 4.7, reviews: 66 },
    { id: "tv-streaming", name: "Boîtier Streaming 4K Pro", badge: "SMART", category: "Streaming", description: "4K HDR10+ Dolby Atmos, Wi-Fi 6 et télécommande vocale. Transformez toute TV en Smart TV.", price: 89000, image: "/images/products/boitier-streaming-4k.png", rating: 4.6, reviews: 203 },
  ],
  electro: [
    { id: "el-robot", name: "Robot Cuisine Samsung Food", badge: "NOUVEAUTÉ", category: "Cuisine Connectée", description: "Robot cuisinier intelligent avec 100+ recettes sénégalaises intégrées.", price: 899000, oldPrice: 1099000, image: "/images/products/robot-cuisine.png", rating: 4.9, reviews: 47 },
    { id: "el-bespoke", name: "Bespoke French Door 680L", badge: "DESIGN", category: "Réfrigération", description: "Réfrigérateur connecté Family Hub avec écran tactile et AI Inside.", price: 2199000, oldPrice: 2699000, image: "/images/presidential/refrigerateur-bespoke.png", rating: 4.8, reviews: 92 },
    { id: "el-clim", name: "Climatiseur Wind-Free AI", badge: "BEST SELLER", category: "Climatisation", description: "Refroidissement sans courant d'air piloté par IA, ultra-silencieux 23dB.", price: 899000, oldPrice: 1099000, image: "/images/presidential/climatiseur-windfree.png", rating: 4.7, reviews: 567 },
    { id: "el-lave", name: "Lave-linge AI Eco 12kg", badge: "INNOVATION", category: "Lavage", description: "Moteur Digital Inverter, détection IA du linge et programme wolof dédié.", price: 749000, oldPrice: 899000, image: "/images/products/lave-linge-ai.png", rating: 4.7, reviews: 218 },
    { id: "el-airfryer", name: "Air Fryer Connecté Premium", badge: "COUP DE CŒUR", category: "Cuisine Connectée", description: "Friteuse sans huile 8L, 12 programmes auto et pilotage smartphone.", price: 129000, oldPrice: 169000, image: "/images/products/air-fryer.png", rating: 4.8, reviews: 389 },
    { id: "el-aspirateur", name: "Aspirateur Robot AI LiDAR", badge: "MAISON PROPRE", category: "Entretien", description: "Cartographie LiDAR 3D, aspiration 5500Pa et vidage automatique.", price: 549000, oldPrice: 699000, image: "/images/products/aspirateur-robot.png", rating: 4.7, reviews: 156 },
    { id: "el-hub", name: "Smart Home Hub Premium", badge: "DOMOTIQUE", category: "Maison Connectée", description: "Hub central SmartThings Matter, pilotage de 200 appareils et scènes IA.", price: 149000, oldPrice: 199000, image: "/images/products/smart-home-hub.png", rating: 4.6, reviews: 274 },
    { id: "el-villa", name: "Villa Présidentielle Intelligente", badge: "DOMOTIQUE D'ÉTAT", category: "Résidence Connectée", description: "Pack domotique complet : 40 pièces pilotées, sécurité IA et éclairage protocolaire.", price: 24999000, oldPrice: 29999000, image: "/images/presidential/villa-presidentielle.png", rating: 5, reviews: 6 },
    { id: "el-lavevaisselle", name: "Lave-vaisselle Connecté 16 Couverts", badge: "NOUVEAUTÉ", category: "Vaisselle", description: "ZoneWash 3e tiroir, 42dB silencieux et programmes dédiés théières. Fini la corvée.", price: 649000, oldPrice: 799000, image: "/images/products/lave-vaisselle-connecte.png", rating: 4.7, reviews: 88 },
    { id: "el-four", name: "Four à Vapeur Intelligent", badge: "GRAND CHEF", category: "Cuisine Connectée", description: "Vapeur pure 100%, 70 recettes automatiques et sonde thermique. Les plats des grands chefs.", price: 949000, image: "/images/products/four-vapeur-intelligent.png", rating: 4.8, reviews: 34 },
    { id: "el-expresso", name: "Machine Expresso Connectée", badge: "CAFFÈ", category: "Café", description: "Extraction 19 bars, moulin intégré et 12 spécialités connectées. Le café de palace.", price: 549000, oldPrice: 649000, image: "/images/products/machine-expresso-connectee.png", rating: 4.8, reviews: 156 },
    { id: "el-purificateur", name: "Purificateur d'Air AI Premium", badge: "SANTÉ", category: "Air Pur", description: "Filtre HEPA 13, capteur PM2.5 temps réel et mode nuit 19dB. L'air pur de la villa.", price: 349000, oldPrice: 429000, image: "/images/products/purificateur-air-ai.png", rating: 4.7, reviews: 143 },
    { id: "el-sechelinge", name: "Sèche-linge HeatPump 10 kg", badge: "EFFICACE", category: "Lavage", description: "Pompe à chaleur A+++, 15 programmes et anti-froissement. Économique et doux.", price: 799000, oldPrice: 949000, image: "/images/products/seche-linge-heatpump.png", rating: 4.6, reviews: 67 },
    { id: "el-induction", name: "Plaque Induction Flex 5 Zones", badge: "PUISSANCE", category: "Cuisine Connectée", description: "5 zones flexibles, booster 3 700W et verrouillage enfant. La cuisson ultra-précise.", price: 549000, image: "/images/products/plaque-induction-flex.png", rating: 4.7, reviews: 52 },
    { id: "el-microonde", name: "Micro-ondes Grill Connecté", badge: "PRATIQUE", category: "Cuisine Connectée", description: "Grill quartz 1 100W, 32 programmes auto et pilotage SmartThings. Rapide et intelligent.", price: 189000, oldPrice: 229000, image: "/images/products/micro-ondes-grill-connecte.png", rating: 4.5, reviews: 189 },
    { id: "el-balai", name: "Aspirateur Balai Sans Fil V10", badge: "LÉGER", category: "Entretien", description: "Aspiration 150AW, 60 min d'autonomie et 1,4kg ultra-léger. Le ménage sans effort.", price: 299000, oldPrice: 349000, image: "/images/products/aspirateur-balai-v10.png", rating: 4.6, reviews: 234 },
  ],
  iot: [
    { id: "iot-watchu", name: "Galaxy Watch Ultra Titanium", badge: "BEST SELLER", category: "Wearable", description: "Titanium Grade 4, GPS multi-band, 100m water resistance. Santé de niveau pro.", price: 549000, oldPrice: 699000, image: "/images/products/galaxy-watch-ultra.png", rating: 4.9, reviews: 89 },
    { id: "iot-montre", name: "Montre d'État « Savoir-Faire »", badge: "HAUTE JOAILLERIE", category: "Horlogerie Prestige", description: "Or massif 18K, 52 diamants et cadran émeraude. Mouvement connecté hybride.", price: 7499000, oldPrice: 9499000, image: "/images/presidential/montre-etat-or.png", rating: 5, reviews: 15 },
    { id: "iot-camera", name: "Caméra IP 4K AI Dome", badge: "SÉCURITÉ", category: "Surveillance", description: "Caméra 4K avec IA de détection, vision nocturne couleur et alertes smartphone.", price: 199000, oldPrice: 249000, image: "/images/products/camera-4k-dome.png", rating: 4.7, reviews: 412 },
    { id: "iot-vr", name: "Casque VR NextGen", badge: "IMMERSION", category: "Réalité Virtuelle", description: "Écrans 4K par œil, suivi oculaire et haptique avancée. Le métaverse premium.", price: 899000, oldPrice: 1099000, image: "/images/products/casque-vr.png", rating: 4.8, reviews: 67 },
    { id: "iot-drone", name: "Drone 4K Pro Cinema", badge: "CINÉMA", category: "Drones", description: "Capteur 4/3 pouces, gimbal 3 axes, 46 min de vol et transmission 20km.", price: 1299000, oldPrice: 1599000, image: "/images/products/drone-4k.png", rating: 4.9, reviews: 98 },
    { id: "iot-buds", name: "Galaxy Buds3 Pro ANC", badge: "AUDIO", category: "Audio Wearable", description: "ANC adaptative, traduction temps réel et design blade premium.", price: 149000, oldPrice: 189000, image: "/images/products/galaxy-buds3-pro.png", rating: 4.8, reviews: 231 },
    { id: "iot-aw", name: "Apple Watch Hermès S9", badge: "LUXE", category: "Wearable", description: "Bracelets Hermès, écran Retina toujours activé et double puce santé.", price: 1299000, image: "/images/products/apple-watch-hermes.png", rating: 4.9, reviews: 41 },
    { id: "iot-bastion", name: "Bastion Présidentiel", badge: "SÉCURITÉ SOUVERAINE", category: "Cybersécurité", description: "Coffre-fort cyber biométrique, SOC privé et chambre blindée TEMPEST.", price: 8999000, oldPrice: 10999000, image: "/images/presidential/bastion-presidentiel.png", rating: 5, reviews: 4 },
    { id: "iot-ring", name: "Galaxy Ring Titanium", badge: "INNOVATION", category: "Wearable", description: "Suivi sommeil, cardio et énergie 24/7, 2,3g titanium et 7 jours d'autonomie. La santé invisible.", price: 449000, image: "/images/products/galaxy-ring-titanium.png", rating: 4.8, reviews: 57 },
    { id: "iot-serrure", name: "Serrure Connectée Biométrique 3D", badge: "SÉCURITÉ", category: "Maison Connectée", description: "Empreinte 3D, code, badge et clé virtuelle. 5 façons d'entrer, zéro pour les autres.", price: 249000, oldPrice: 299000, image: "/images/products/serrure-connectee-biometrique.png", rating: 4.7, reviews: 96 },
    { id: "iot-sonnette", name: "Sonnette Vidéo IA 2K", badge: "ACCUEIL", category: "Surveillance", description: "Vidéo 2K HDR, détection IA humaine/colis et discussion 2 voies. Voyez qui frappe, partout.", price: 149000, oldPrice: 179000, image: "/images/products/sonnette-video-ia.png", rating: 4.6, reviews: 167 },
    { id: "iot-balance", name: "Balance Santé Connectée Pro", badge: "BIEN-ÊTRE", category: "Santé", description: "13 mesures corporelles, fréquence cardiaque et rapport mensuel dans l'app. Vos objectifs, mesurés.", price: 69000, oldPrice: 89000, image: "/images/products/balance-sante-connectee.png", rating: 4.5, reviews: 312 },
    { id: "iot-traceur", name: "Traceur GPS Premium 4G", badge: "TRANQUILLITÉ", category: "Localisation", description: "Géolocalisation temps réel 4G, géo-clôture et batterie 30 jours. Véhicules, bagages, famille.", price: 99000, image: "/images/products/traceur-gps-4g.png", rating: 4.6, reviews: 178 },
    { id: "iot-piscine", name: "Robot de Piscine IA", badge: "VILLA", category: "Extérieur", description: "Nettoyage fond, parois et ligne d'eau, cartographie IA et station sans fil. Piscine éclatante.", price: 899000, oldPrice: 1099000, image: "/images/products/robot-piscine-ia.png", rating: 4.8, reviews: 29 },
    { id: "iot-lampe", name: "Lampe Designer Connectée Or", badge: "LUMIÈRE", category: "Éclairage", description: "16M couleurs, scènes protocolaires et arc doré sculptural. La lumière comme un bijou.", price: 129000, image: "/images/products/lampe-designer-connectee.png", rating: 4.7, reviews: 84 },
    { id: "iot-meteo", name: "Station Météo Connectée Premium", badge: "PRÉCISION", category: "Extérieur", description: "Capteur 7-en-1, prévisions 7 jours et alertes hivernage. Le temps maîtrisé.", price: 99000, image: "/images/products/station-meteo-connectee.png", rating: 4.6, reviews: 121 },
  ],
  cloud: [
    { id: "cl-pack", name: "Solution Pro Complète", badge: "BEST VALUE", category: "Pack Pro", description: "PC Portable + Imprimante + Routeur 5G + installation clé en main. Support 24/7.", price: 1499000, oldPrice: 1899000, image: "/images/products/pc-pro-pack.png", rating: 4.8, reviews: 203 },
    { id: "cl-laptop", name: "Laptop Ultraportable Or-Titane", badge: "PRESTIGE", category: "Ordinateur", description: "17mm d'épaisseur, écran 4K OLED tactile et 22h d'autonomie. Finition or-titane.", price: 1899000, oldPrice: 2299000, image: "/images/products/laptop-ultraportable.png", rating: 4.9, reviews: 71 },
    { id: "cl-ecran", name: "Écran Pro 32\" 4K USB-C", badge: "PRODUCTIVITÉ", category: "Écran Pro", description: "Dalle IPS 4K 99% DCI-P3, hub USB-C 90W et pied ergonomique or.", price: 349000, oldPrice: 449000, image: "/images/products/ecran-pro-32.png", rating: 4.8, reviews: 134 },
    { id: "cl-imprimante", name: "Imprimante LaserJet Pro M404", badge: "ESSENTIEL", category: "Impression", description: "Impression recto-verso automatique, sécurité NFC et toner XL inclus.", price: 399000, oldPrice: 469000, image: "/images/products/imprimante-laserjet.png", rating: 4.6, reviews: 287 },
    { id: "cl-routeur", name: "Routeur 5G WiFi 7 Elite", badge: "CONNECTIVITÉ", category: "Réseau", description: "Débits 19 Gb/s, 200 appareils simultanés et failover 5G automatique.", price: 249000, oldPrice: 299000, image: "/images/products/routeur-wifi7.png", rating: 4.7, reviews: 168 },
    { id: "cl-gaming", name: "Setup Gamer Elite", badge: "PRO GAMER", category: "Gaming", description: "PC RTX 5090 + Monitor OLED 240Hz + périphériques méca. Le setup ultime.", price: 4999000, oldPrice: 5999000, image: "/images/products/gaming-setup.png", rating: 4.9, reviews: 87 },
    { id: "cl-bureau", name: "Bureau du Sommet", badge: "SETUP PRÉSIDENTIEL", category: "Bureau d'Exception", description: "Palissandre massif, laptop or-titane, téléphone quantique et dashboard national.", price: 12499000, oldPrice: 14999000, image: "/images/presidential/bureau-du-sommet.png", rating: 5, reviews: 5 },
    { id: "cl-conseil", name: "Table du Conseil Suprême 86\"", badge: "GOUVERNEMENT DIGITAL", category: "Tableau Interactif", description: "Table tactile 8K 86\", visioconférence souveraine et vote électronique sécurisé.", price: 19999000, oldPrice: 24999000, image: "/images/presidential/table-conseil-supreme.png", rating: 5, reviews: 3 },
    { id: "cl-station", name: "Station de Travail Créateurs RTX", badge: "CRÉATEURS", category: "Ordinateur", description: "RTX 5080, Ryzen 9 et 64 Go DDR5 pour le rendu 8K. La bête de rendu des studios.", price: 2999000, oldPrice: 3499000, image: "/images/products/station-travail-rtx.png", rating: 4.9, reviews: 43 },
    { id: "cl-minipc", name: "Mini PC Pro Silencieux", badge: "COMPACT", category: "Ordinateur", description: "Core i9, 32 Go et 1 To NVMe dans 0,8L silencieux. La puissance qui disparaît.", price: 549000, oldPrice: 649000, image: "/images/products/mini-pc-pro.png", rating: 4.7, reviews: 78 },
    { id: "cl-nas", name: "NAS Enterprise 4 Baies", badge: "BACKUP", category: "Stockage", description: "RAID 5/6/10, 4×12 To supportés et sauvegarde chiffrée hors-site. Vos données, à jamais.", price: 749000, oldPrice: 899000, image: "/images/products/nas-enterprise-4baies.png", rating: 4.8, reviews: 51 },
    { id: "cl-onduleur", name: "Onduleur Intelligent 3kVA", badge: "JAMAIS SANS COURANT", category: "Énergie", description: "Sinus pur 3kVA, bascule 0ms et monitoring app. Le courant continue, même sans courant.", price: 299000, oldPrice: 349000, image: "/images/products/onduleur-intelligent.png", rating: 4.7, reviews: 139 },
    { id: "cl-scanner", name: "Scanner Document Pro 80ppm", badge: "DÉMATÉRIEL", category: "Bureautique", description: "80 pages/min recto-verso, OCR wolof/français et numérisation cloud. Le papier disparaît.", price: 449000, oldPrice: 529000, image: "/images/products/scanner-document-pro.png", rating: 4.6, reviews: 62 },
    { id: "cl-visio", name: "Barre de Visioconférence 4K IA", badge: "RÉUNIONS", category: "Visioconférence", description: "Caméra 4K grand-angle, cadrage IA des intervenants et audio 360°. Réunions au niveau État.", price: 549000, oldPrice: 649000, image: "/images/products/barre-visioconference-4k.png", rating: 4.8, reviews: 47 },
    { id: "cl-casqueuc", name: "Casque Bureautique Certifié UC", badge: "CALL CENTER", category: "Audio Pro", description: "Certifié Teams/Zoom, micro anti-bruit et 40h d'appels. Le confort des longues journées.", price: 89000, image: "/images/products/casque-bureautique-uc.png", rating: 4.5, reviews: 214 },
    { id: "cl-pos", name: "Terminal Point de Vente Intelligent", badge: "COMMERÇANTS", category: "Encaissement", description: "Écran double face, Wave/OM/Visa et ticket imprimé. L'encaissement moderne des boutiques.", price: 399000, oldPrice: 469000, image: "/images/products/terminal-point-de-vente.png", rating: 4.8, reviews: 103 },
  ],
};

// ═══════════ BOUTIQUES FUSIONNÉES (base + extensions catalogue 1000 trésors) ═══════════
export const boutiques: Record<string, Product[]> = {
  mobile: [...boutiquesBase.mobile, ...boutiquesExt.mobile],
  "tv-av": [...boutiquesBase["tv-av"], ...boutiquesExt["tv-av"]],
  electro: [...boutiquesBase.electro, ...boutiquesExt.electro],
  iot: [...boutiquesBase.iot, ...boutiquesExt.iot],
  cloud: [...boutiquesBase.cloud, ...boutiquesExt.cloud],
};

// Collections phares du catalogue étendu (Univers Tech + 36 Fiches Premium)
export { fichesPremium, universTech };
